module.exports = __webpack_public_path__ + "static/media/quiikmeet-10.3b58735a.png";